import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import {  ChartOptions } from "chart.js";
import { request } from 'http';
import { KButtonType } from 'ng-k-button';
import { AsbestosRadiologicalProgressionService } from 'src/app/services/asbestos-radiological-progression.service';
import { GlobalLoadingService } from 'src/app/services/global-loading.service';

@Component({
  selector: 'app-asbestos-radiological-progression-chart',
  templateUrl: './asbestos-radiological-progression-chart.component.html',
  styleUrls: ['./asbestos-radiological-progression-chart.component.scss']
})
export class AsbestosRadiologicalProgressionChartComponent implements OnInit {

  @Input() claimId: any = '';
  @Input() radProgId: any = '';
  @Input() category: any = [];
  public graphData: any = [];

  KButtonType = KButtonType;

  DATA_COUNT = 10;

  NUMBER_CFG = {count: this.DATA_COUNT, min: -100, max: 100};public displaySuccess: boolean = false;
  public displayError: boolean = false;
  public successText!: string;
  public errorText!: string;
  public timeout!: number;
  public chartData = [];
  // public category: any = [];

  searchText = '';
  options: any[] = [];
  filteredOptions: any[] = [];
  selectedOptions: any[] = [];
  dropdownOpen = false;
  inputWidth = '100%';
  public allMeasurementTypes: any = [];
  public measurementTypeList: any[];
  public selectedMeasurementParams: any = [];

  public measurementDict:any = {
    'body_mass_index': 'Body Mass Index',
    'radiological_progression_fibrosis': 'Radiological Progression (Fibrosis)',
    'radiological_progression_thickening': 'Radiological Progression (Thickening)',
    'radiological_progression_plaques': 'Radiological Progression (Plaques)',
    'forced_vital_capacity_fvc': 'Forced Vital Capacity (FVC)',
    'forced_expiratory_volume_in_1_second_fev1': 'Forced Expiratory Volume in 1 Second (FEV1)',
    'exercise_tolerance': 'Exercise Tolerance',
    'fev1/fvc': 'FEV1/FVC'
  };

  // dummyData:any = {
  //   labels: [ ['62', '2016'], ['63', '2017'] , ['64', '2018'], ['6', '2016'], ['62', '2016'], ['62', '2016'] ],
  //   "datasets": [
  //     {
  //         "label": "Radiological Progresion",
  //         "data": [
  //             10,
  //             200,
  //             300,
  //             400,
  //             500,
  //             600
  //         ],
  //         "borderColor": "green",
  //         "backgroundColor": "rgba(0, 128, 0, 0.5)",
  //         "yAxisID": "y"
  //     },
  //     {
  //         "label": "Body Mass Index (BMI)",
  //         "data": [
  //             101,
  //             220,
  //             330,
  //             440,
  //             550,
  //             660
  //         ],
  //         "borderColor": "orange",
  //         "backgroundColor": "rgba(255, 165, 0, 0.5)",
  //         "yAxisID": "y"
  //     },
  //     {
  //         "label": "FVC",
  //         "fill": false,
  //         "backgroundColor": "green",
  //         "borderColor": "blue",
  //         "borderDash": [
  //             5,
  //             5
  //         ],
  //         "data": [
  //             100,
  //             250,
  //             379,
  //             489,
  //             501,
  //             602
  //         ],
  //         "yAxisID": "y1"
  //     }
  // ]
  // }

  legends = true;

  public graphYAxisTextDict: any = {
    'y1': 'Exercise Tolerance / Disability (%)',
    'y' : 'Lung Function (L)',
    'y2' : 'Body Mass Index (kg/m²)',
    'y3' : 'Radiological Progression'
  }

  graphOptions: ChartOptions = {
    responsive: true,
    interaction: {
      mode: 'index',
      intersect: false,
    },
    plugins: {
      title: {
        display: true,
        text: 'Radiological Progression Chart',
        position: 'bottom',
        padding: 20,
        font: {
          size: 15,
          weight: 'bold'
        }
      },
      // subtitle:  {
      //   display: true,
      //   text: 'Age',
      //   position: 'bottom'
      // },
      // legend: {
      //   title: {
      //     display: true,
      //     text: 'Legend Title'
      //   }
      // }
    },
    scales: {
      x: {
        display: true,
        title: {
          display: true,
          text: 'Age',
          font: {
            size: 15,
            weight: 'bold'
          }
        },
        grid: {
          drawOnChartArea: false, // only want the grid lines for one axis to show up
        },
      },
      y: {
        type: 'linear',
        display: false,
        position: 'left',
        title: {
          display: true,
          text: 'Lung Function (L)',
          font: {
            size: 15,
            weight: 'bold'
          }
        },
        // grid line settings
        grid: {
          drawOnChartArea: false, 
        },
      },
      y1: {
        type: 'linear',
        display: false,
        position: 'left',
        title: {
          display: true,
          text: 'Exercise Tolerance / Disability (%)',
          font: {
            size: 15,
            weight: 'bold'
          }
        },
        grid: {
          drawOnChartArea: false, 
        },
      },
      y2: {
        type: 'linear',
        display: false,
        position: 'right',
        title: {
          display: true,
          text: 'Body Mass Index (kg/m²)',
          font: {
            size: 15,
            weight: 'bold'
          }
        },
        grid: {
          drawOnChartArea: false, 
        },
      },
      y3: {
        type: 'linear',
        display: false,
        position: 'right',
        title: {
          display: true,
          text: 'Radiological Progression',
          font: {
            size: 15,
            weight: 'bold'
          }
        },
        grid: {
          drawOnChartArea: false, 
        },
      },
    }
  }
  
  config: any = {
    type: 'line',
    options: this.graphOptions,
  };

  constructor(
    private router: Router,
    private loaderService: GlobalLoadingService,
    private asbestosRadProgService: AsbestosRadiologicalProgressionService
  ) { }

  ngOnInit(): void {
    // this.getChartData();
    this.retrieveChartData(["all"])
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['category']) {
      this.category = changes['category'].currentValue;
      // this.getChartData();
    }
  }

  public retrieveChartData(category: any) {
    const thisObj = this;
    const requestParam: any = {};
    requestParam.claimId = this.claimId ? this.claimId : null;
    requestParam.id = this.radProgId ? this.radProgId : null;
    requestParam.category = category;
    this.loaderService.startLoadingIndicator('retrieveChartData');

    thisObj.asbestosRadProgService.getChartData(requestParam).subscribe(result => {
      if (result.status === 'Success') {
        this.loaderService.stopLoadingIndicator('retrieveChartData');
        this.measurementTypeList = result.data.filterSet
        this.selectedMeasurementParams = result.data.filterData;
        // console.log(this.selectedMeasurementParams)
        // this.selectedMeasurementParams = [{key: "exercise_tolerance", value: "Exercise Tolerance"}];
        // this.selectedMeasurementParams = ['exercise_tolerance']
        if (this.selectedMeasurementParams?.length) { 
          console.log('filterdata available');
          if(this.category.length != 0) {
            console.log('this.category not empty')
            console.log(this.selectedOptions)
          } else {
            console.log('this.category empty')
            if (result.data.datasets.length !=0 && result.data.labels.length !=0 ) {
              this.selectedMeasurementParams.forEach((option: any) => {
                this.selectedOptions.push({key: option, value: this.measurementDict[option]});
              });
              this.category = this.selectedMeasurementParams
            }            
          }
          // console.log(this.selectedMeasurementParams)
          console.log(category)
         
          // this.category = result.data.filterData;
          console.log(this.category)
          this.setGraph(result)
          // console.log(this.selectedOptions)
          // this.category = [];
          // for (let opt of this.selectedOptions) {
          //   // console.log(opt['key'])
          //   this.category.push(opt['key'])
          // }
        } else {
          console.log('no filterdata available');
          console.log(requestParam.category)
          if (requestParam.category.includes("all")) {
            console.log("Category contains 'all'");

            for (const [key, value] of Object.entries(this.measurementTypeList)) {
              this.selectedOptions.push({key: key, value: this.measurementDict[key]});
            }
            this.category = ["all"];
            this.setGraph(result)
          } else {
            console.log("Category not includes  'all'");
            this.selectedOptions = []
            for (let key of requestParam.category) {
              this.selectedOptions.push({key: key, value: this.measurementDict[key]});
            }
            this.setGraph(result)
          }
        }
      }
    },
    err => {
      console.log(err.error);
      this.loaderService.stopLoadingIndicator('retrieveChartData');
      if (err.error.status === 'Unprocessable') {
        this.loaderService.stopLoadingIndicator('retrieveChartData');
        // this.claimData = [];
        // this.errorText = err.error.Message;
        // this.showMessage('error', 2000);
        // setTimeout(() => {
        //   this.displayError = false;
        // }, 2010);
      }
    });
  }

  public setGraph(result: any) {
    this.graphData = result.data;
    let displayAxis = result.data.yAxisMarker;
    let trueIndex = [];
    for (const [index, [key, value]] of Object.entries(displayAxis).entries()) {
      // console.log(`Index: ${index}, Key: ${key}, Value: ${value}`);
     
      if (value) {
        trueIndex.push(key)
      }
      if (this.graphOptions.scales) {
        this.graphOptions.scales[key] = {
          ...this.graphOptions.scales[key],
          display: !!value, // Ensures boolean value,
        };
       
     }
    }

    // console.log(trueIndex)
    for (const [index, value] of trueIndex.entries()) {
      // console.log(`Index: ${index}, Value: ${value}`);
      // console.log(this.options.scales)

      if (this.graphOptions.scales) { 
        if (index % 2 == 0) {
          this.graphOptions.scales[value] = {
            position: 'left', // Ensures boolean value,
            type: 'linear',
            grid: {
              drawOnChartArea: false, // only want the grid lines for one axis to show up
            },
            title: {
              display: true,
              text:  this.graphYAxisTextDict[value],
              font: {
                size: 15,
                weight: 'bold'
              }
            },
          };
        } else {
          this.graphOptions.scales[value] = {
            position: 'right', // Ensures boolean value
            type: 'linear',
            grid: {
              drawOnChartArea: false, // only want the grid lines for one axis to show up
            },
            title: {
              display: true,
              text:  this.graphYAxisTextDict[value],
              font: {
                size: 15,
                weight: 'bold'
              }
            },
          };
        }
       
      }
    }
  }

  public getChartData() {
    const thisObj = this;
    const requestParam: any = {};
    requestParam.claimId = this.claimId ? this.claimId : null;
    requestParam.id = this.radProgId ? this.radProgId : null;
    requestParam.category = this.category? this.category : [];
    this.loaderService.startLoadingIndicator('getChartData');

    thisObj.asbestosRadProgService.getChartData(requestParam).subscribe(result => {
      if (result.status === 'Success') {
        this.loaderService.stopLoadingIndicator('getChartData');
        this.graphData = result.data;
        let displayAxis = result.data.yAxisMarker;
        let trueIndex = [];
        for (const [index, [key, value]] of Object.entries(displayAxis).entries()) {
          // console.log(`Index: ${index}, Key: ${key}, Value: ${value}`);
         
          if (value) {
            trueIndex.push(key)
          }
          if (this.graphOptions.scales) {
            this.graphOptions.scales[key] = {
              ...this.graphOptions.scales[key],
              display: !!value, // Ensures boolean value,
            };
           
         }
        }

        // console.log(trueIndex)
        for (const [index, value] of trueIndex.entries()) {
          // console.log(`Index: ${index}, Value: ${value}`);
          // console.log(this.options.scales)

          if (this.graphOptions.scales) { 
            if (index % 2 == 0) {
              this.graphOptions.scales[value] = {
                position: 'left', // Ensures boolean value,
                type: 'linear',
                grid: {
                  drawOnChartArea: false, // only want the grid lines for one axis to show up
                },
                title: {
                  display: true,
                  text:  this.graphYAxisTextDict[value],
                  font: {
                    size: 15,
                    weight: 'bold'
                  }
                },
              };
            } else {
              this.graphOptions.scales[value] = {
                position: 'right', // Ensures boolean value
                type: 'linear',
                grid: {
                  drawOnChartArea: false, // only want the grid lines for one axis to show up
                },
                title: {
                  display: true,
                  text:  this.graphYAxisTextDict[value],
                  font: {
                    size: 15,
                    weight: 'bold'
                  }
                },
              };
            }
           
          }
        }

        for (const [key, value] of Object.entries(displayAxis)) {
        //   if (this.options.scales) {
        //     if(value) {
        //       console.log('KEY : ' + key)
        //       this.options.scales[key]  = {
        //         ... this.options.scales[key],
        //         display: true
        //       }
        //     } else {
        //       this.options.scales[key]  = {
        //         ... this.options.scales[key],
        //         display: false
        //       }
        //     }
           
        //  }
        };
      }
    },
    err => {
      console.log(err.error);
      this.loaderService.stopLoadingIndicator('getChartData');
      if (err.error.status === 'Unprocessable') {
        this.loaderService.stopLoadingIndicator('getChartData');
        // this.errorText = err.error.Message;
        // this.showMessage('error', 2000);
        // setTimeout(() => {
        //   this.displayError = false;
        // }, 2010);
      }
    });
  }

  async fetchMeasurementTypesList() {
    this.options = [];
    this.filteredOptions = [];
    const dataArray = Object.entries(this.measurementTypeList).map(([key, value]) => ({ key, value }));
      // console.log(dataArray)
    // this.filteredOptions.push({marker: 'D2-40', matchValue: 100});
    dataArray.forEach((measurement: any) => {
      this.options.push(measurement);
      this.filteredOptions.push(measurement);
    });
  }

  isSelected(option: any): boolean { 
    const selected = this.selectedOptions.filter((selected) =>
      selected?.key === option.key
    );
    return selected.length ? true : false;
  }

  removeSelection(option: any) {
    this.selectedOptions = this.selectedOptions.filter(
      (selected) => selected.key !== option.key
    );
    // this.findCausationProbability(this.selectedOptions);
    // this.updateInputWidth();
    this.category = [];
    for (let opt of this.selectedOptions) {
      this.category.push(opt['key'])
    }
    if(this.selectedOptions.length != 0) {
    } else {
      this.category = [];
    }
    this.retrieveChartData(this.category)
  }

  toggleSelection(option: any) { 
    console.log(this.selectedOptions)
    if (this.isSelected(option)) { console.log('uuu')
      this.selectedOptions = this.selectedOptions.filter(
        (selected) => selected.key !== option.key
      );
    } else { console.log('yy')
      this.selectedOptions.push(option);
    }
    console.log(this.selectedOptions)
    this.category = [];
    for (let opt of this.selectedOptions) {
      this.category.push(opt['key'])
    }
    if(this.selectedOptions.length != 0) {
    } else {
      console.log(this.selectedOptions)
      this.category = [];
    }
    console.log(this.category);
    this.retrieveChartData(this.category)
  }

  async toggleDropdown() {
    if (!this.allMeasurementTypes.length) {
      await this.fetchMeasurementTypesList();
    }
    this.dropdownOpen = !this.dropdownOpen;
  }

  filterOptions() {
    if (this.searchText) {
      this.dropdownOpen = true;
    } else {
      this.dropdownOpen = false;
    }
    this.filteredOptions = this.options.filter((option) =>
      option?.value.toLowerCase().includes(this.searchText.toLowerCase())
    );
  }

  public saveChartParams() {
    console.log(this.category)
    if (this.category.length !=0) {
      const thisObj = this;
      const requestParam: any = {};
      requestParam.claimId = this.claimId ? this.claimId : null;
      requestParam.id = this.radProgId ? this.radProgId : null;
      requestParam.filterSet = this.category? this.category : [];
      this.loaderService.startLoadingIndicator('saveChartParams');
  
      thisObj.asbestosRadProgService.saveChartParams(requestParam).subscribe(result => {
        if (result.status === 'Success') {
          this.loaderService.stopLoadingIndicator('saveChartParams');
          this.successText = "Chart Configuration Saved";
          this.showMessage('success', 2000);
          setTimeout(() => {
            this.router.navigate(['/claimDetail/', this.claimId, 'medical']);
          }, 2010);
        }
      },
      err => {
        console.log(err.error);
        this.loaderService.stopLoadingIndicator('saveChartParams');
      });
    } else {
      this.errorText = "Please select atleast 1 measurement.";
      this.showMessage('error', 2000);
      setTimeout(() => {
        this.displayError = false;
      }, 2010);
    }
    
  }

  public showMessage(msgType: any, timeout: any) {
    this.displaySuccess = false;
    this.displayError = false;
    if (msgType === 'success') {
      this.displaySuccess = true;
    }
    if (msgType === 'error') {
      this.displayError = true;
    }
    if (timeout) {
      this.timeout = timeout;
    }
  }

}
